import api from '@puzzleapps/shared/src/utils/api'
import Vue from 'vue'

const state = {
    // appId: null,
    puzzleId: null,
    playId: null,
    isPlaying: false,
    isPaused: false,
    completed: false,
    finishRecorded: false,
    hintsUsed: 0,
    totalTime: 0,
    points: null,
    type: '',
    name: '',
    titleHtml: null,
    triviaHiScore: 0,
    gameLoaded: false,
    level: '',
    competitionID: 0,
    competitionTitle: '',
    unauthorised: false
}

const sudokuHintPenaltyMultiplier = 15000
const HintPenaltyMultiplier = 10000

const getters = {
    getCompleted: state => state.completed,

    totalTimeInSeconds: state => {
        let totalSeconds = parseInt(state.totalTime / 1000) 
        return totalSeconds;
    },

    formattedTotalTime: state => {
        let seconds = Math.floor((state.totalTime / 1000) % 60)
                        .toLocaleString('en-GB', {minimumIntegerDigits: 2})
        let minutes = Math.floor((state.totalTime / 1000 / 60) % 60)
                        .toLocaleString('en-GB', {minimumIntegerDigits: 2})
        let hours = Math.floor((state.totalTime / 1000 / 60 / 60) % 60)

        if (hours !== 0)
            return `${hours}:${minutes}:${seconds}`
        else
            return `${minutes}:${seconds}`


           /* let hours = Math.floor(state.totalTime / 3600);
            let minutes = Math.floor((state.totalTime % 3600) / 60);
            let secondsRemainder = state.totalTime % 60;
            let hoursString = hours.toString().padStart(2, '0');
            let minutesString = minutes.toString().padStart(2, '0');
            let secondsString = secondsRemainder.toString().padStart(2, '0');
    
            if(hours > 0)
              return `${hoursString}:${minutesString}:${secondsString}`;
            else
              return `${minutesString}:${secondsString}`;*/
    },

    formattedAdjustedTime: state => {
        let penaltyMultiplier = HintPenaltyMultiplier/1000

        if(state.type === "sudoku")
            penaltyMultiplier = sudokuHintPenaltyMultiplier/1000

        let totalSeconds = parseInt(state.totalTime  / 1000) + parseInt(state.hintsUsed * penaltyMultiplier)  // adds 10s penalty for every letter hint used
//return totalSeconds

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    if(h > 0)
        return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    else
        return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
        
    }
}

const actions = {

    // TODO split up inits
    init({ commit, state, dispatch, rootState }) {
        
        dispatch('setCompleted', false)
        
        dispatch('grid/fetchPuzzle', this.type, {root: true})
        .then(res => {
            
            let local = localStorage.getItem(`puzzle-${ state.puzzleId }`)
            local = JSON.parse(local)

            if (local && local.totalTime > 0) {
                commit('SET_TOTAL_TIME', local.totalTime)
                commit('SET_HINTS_USED', local.hintsUsed)
                commit('SET_PLAY_ID', local.playId)
                commit('SET_FINISH_RECORDED', local.finishRecorded)
            }

            if (state.type === 'crossword')                
                dispatch('cluelist/setClues', res.w, {root: true})
                
            dispatch('setIsPlaying', true)    
            dispatch('setPlayId')
            dispatch('saveToLocal')
            dispatch('grid/checkCompleted', null, {root: true})
            dispatch('setGameLoaded',true)
            //dispatch('setInitialized', true)
            
        })
    },

    finishGame({ dispatch, state }) {
        if(state.type === 'trivia')
            dispatch('triviaHiScore', state.points);

        dispatch('setCompleted', true)
        dispatch('saveToLocal', true)
        dispatch('recordFinish', true)  

        
        if(state.type === 'crossword' || state.type === 'wordsearch' || state.type === 'codecracker' )
        {
            dispatch('setPuzzleBestTime', state.totalTime, state.hintsUsed)
            if(state.type === 'crossword'){
                
                 //deselect all cells for competition entry
                 dispatch('grid/deselectAllCells', null, {root: true})
            }
        }
            

        if(state.type === 'sudoku')
            dispatch('setSudokuBestTime', state.totalTime, state.hintsUsed)
   
    },

    setPuzzleId({ commit }, puzzleId) {
        commit('SET_PUZZLE_ID', puzzleId)
    },

    setPuzzleLevel({ commit }, level)
    {
        commit('SET_PUZZLE_LEVEL', level)
    },

    goToPuzzleRoute({ dispatch }, {router, id, desc}) {
        
        var levelFriendlyName = desc
        if (desc.includes('Level 1')) {
            levelFriendlyName = "easy"
          }
          else if (desc.includes('Level 2')) {
            levelFriendlyName = "medium"
          }
          else if (desc.includes('Level 3')) {
            levelFriendlyName = "hard"
          }
          else if (desc.includes('Level 4')) {
            levelFriendlyName = "difficult"
          }
          else if (desc.includes('Level 5')) {
            levelFriendlyName = "genius"
          }

        dispatch('setPuzzleId', id)
        dispatch('setPuzzleLevel', levelFriendlyName)

        router.push({
            name: 'Game',
            params: {
                clientAppId: window.PE_CLIENTAPP_ID,
            },
            path: '/game',
            query: {
                t: new Date().getTime(),
            }
        })
    },
    
    // use to destroy local state on puzzle exits
    clearPuzzleState({ commit, state, dispatch }) {
        if (state.type === 'wordsearch')
            dispatch('wordlist/clearState', null, {root: true})

        dispatch('grid/clearCells', null, {root: true})
        commit('SET_PUZZLE_ID', null)
        commit('SET_TOTAL_TIME', 0)
        commit('SET_HINTS_USED', 0)
        commit('SET_PLAY_ID', null)
        commit('SET_FINISH_RECORDED', false)
        
    },
        
    hint({ commit, state, dispatch, rootState }) {
        
        if (state.type === 'crossword' && rootState.grid.selectedCell)
            dispatch('grid/revealLetter', null, {root: true})
        else if (state.type === 'sudoku' && rootState.grid.selectedCell)
            dispatch('grid/revealSelected', null, {root: true})
        else if (state.type === 'wordsearch')
            dispatch('wordlist/hint', null, {root: true})
        else
            return
        
            
        commit('INCREMENT_HINTS_USED') //** not sure if this should be used here as it attributes to the hint counter accuracy problems */
    },

    codeCrackerHint({ commit, state, dispatch, rootState }) {
        if (state.type === 'codecracker' && rootState.grid.selectedCell)
        {
            const GridAlreadyCorrect = dispatch('grid/revealCodeCrackerLetters', null, {root: true})
            // result is returned as a promise so we access it the way below
            GridAlreadyCorrect.then((result) => {
                if(!result) // in this case result means the word was already correct. So false will trigger the hint counter
                {
                    commit('INCREMENT_HINTS_USED')
                }
            });
            
            dispatch('grid/checkCompleted', null, {root: true})
        }
    },

    sudokuHint({ commit, state, dispatch, rootState })
    {
        if (state.type === 'sudoku' && rootState.grid.selectedCell)
        {
            const GridAlreadyCorrect = dispatch('grid/revealSelected', null, {root: true})
            // result is returned as a promise so we access it the way below
            GridAlreadyCorrect.then((result) => {
                if(!result) // in this case result means the word was already correct. So false will trigger the hint counter
                {
                    commit('INCREMENT_HINTS_USED')

                    // remove corresponding pencil marks
                    let payload = {
                        row: rootState.grid.selectedCell.row,
                        col: rootState.grid.selectedCell.col,
                        input: rootState.grid.selectedCell.solution,
                    }

                    dispatch('clearRelatedPencilMarksAfterHint', payload)
                }
            });
        }
            


    },

    crosswordHint({ commit, state, dispatch, rootState }, hintType) {
        if (state.type === 'crossword' && rootState.grid.selectedCell)
        {
            if(hintType == "word")
            {
                const WordAlreadyCorrect = dispatch('grid/revealWord', null, {root: true})
                
                // result is returned as a promise so we access it the way below
                WordAlreadyCorrect.then((result) => {
                    if(!result.cellsAlreadyCorrect) // in this case result means the word was already correct. So false will trigger the hint counter
                    {
                        commit('INCREMENT_HINTS_USED', result.hintsUsed)
                    }
                });
                if(!WordAlreadyCorrect)
                {
                    commit('INCREMENT_HINTS_USED')
                }
            }
                

            if(hintType == "letter")
            {
                const LetterAlreadyCorrect = dispatch('grid/revealLetter', null, {root: true}) //return false indicates the letter was not already correct and therefore the hint counter can be incrmented

                // result is returned as a promise so we access it the way below
                LetterAlreadyCorrect.then((result) => {
                    if(!result)
                    {
                        commit('INCREMENT_HINTS_USED')
                    }

                  });
            }
        }
        if(state.type === 'wordsearch'){
            dispatch('wordsearchHint', hintType)
        }
    },

    wordsearchHint({ commit, state, dispatch, rootState }, hintType) {
        if(hintType == "word")
        {
            dispatch('wordlist/hint', null, {root: true})
            commit('INCREMENT_HINTS_USED',15) // we give a penalty of 15 for whole word hints
        }

        if(hintType == "letter")
        {
            let status = !rootState.wordlist.letterHintMode
            
            dispatch('wordlist/letterHint', status, {root: true})
            // we don't increment the hint counter here but do it once a word has been selected on the list which is done on the wordsearch/word component. From there it calls the function below called incrementHintCounter

        }
    },

    incrementHintCounter({ commit }, hintCount = 1){
        commit('INCREMENT_HINTS_USED', hintCount)
    },

    keyboardPress({ state, commit, dispatch, rootState }, payload)
    {
        dispatch('grid/keyPress', payload, {root: true})
    },

    resetPuzzle({ state, commit, dispatch, rootState }) {
        
        commit('SET_COMPLETED', false)
        commit('SET_TOTAL_TIME', 0)
        commit('SET_HINTS_USED', 0)

        if (state.type === 'wordsearch')
            dispatch('wordlist/clearAllInputs', null, {root: true})
        else if(state.type === 'codecracker')
            dispatch('grid/clearAllCCInputs', null, {root: true}) 
        else
            dispatch('grid/clearAllInputs', null, {root: true})    
        
        // clearInterval(interval)
        dispatch('saveToLocal')
        dispatch('setIsPlaying', true)

        //if (state.type === 'wordsearch')
            //dispatch('wordlist/clearState', null, {root: true})


    },
    
    // record a play to the database and retrive the id returned
    setPlayId({ dispatch, state, commit }) {
        let local = localStorage.getItem(`puzzle-${ state.puzzleId }`)
        local = JSON.parse(local)

        if (!state.puzzleId)
            throw new Error('Puzzle ID not set')

        // if (!local || !local.playId) {
            // if no play id, retrive it from the API
            dispatch('recordPlay')
            .then(playId => {
                commit('SET_PLAY_ID', playId)
                dispatch('saveToLocal')
            })
            .catch(err => {
                throw new Error(err)
            })
        // }
    },

    setCompetitionInfo({ dispatch, state, commit }, compDetails){
        if(compDetails.message !== "undefined")
        {
            commit('SET_COMPETITION_ID', compDetails.data.id)
            commit('SET_COMPETITION_TITLE', compDetails.data.Title)

            dispatch('userSettings/setGameMode','challenge',{root: true})
        }
        else
        {
            commit('SET_COMPETITION_ID', 0)
            commit('SET_COMPETITION_TITLE', '')
        }
    },

    recordPlay({ state, rootState }) {
        return new Promise((resolve, reject) => {
            // let clientAppId = window.PE_CLIENTAPP_ID

            if (state.completed)
                resolve('Puzzle already completed')

            api.play({
                clientAppId: window.PE_CLIENTAPP_ID,
                puzzleId: state.puzzleId,
                userId: null,
                playId: state.playId,
                challengeMode: (rootState.userSettings.gameMode === 'challenge') ? 1 : 0,
            })
            .then(playId => resolve(playId))
        })
    },

    recordFinish({ dispatch, commit, state, getters, rootState }) {
        
        return new Promise((resolve, reject) => {
    
            if (state.finishRecorded) {
                resolve(state.playId)
            }
            else {
                
                api.finish({
                    clientAppId: window.PE_CLIENTAPP_ID,
                    finishedAt: new Date(),
                    playId: state.playId,
                    puzzleId: state.puzzleId,
                    totalTimeInSeconds: getters.totalTimeInSeconds,
                    userId: null,
                    points: state.points,
                    hintsUsed: state.hintsUsed,
                })
                .then(playId => {
                   // dispatch('triviaHiScore', state.points);
                    commit('SET_FINISH_RECORDED', true)
                    dispatch('saveToLocal')
                    resolve(playId)
                })
                .catch( console.error('Save error '))
            }
        })
    },
    
    addPoints({ commit }, points) {
        commit('ADD_POINTS', points)

        if(state.points > state.triviaHiScore)
            commit('SET_TRIVIA_HI_SCORE', points)
    },

    resetTrivia({  commit }, points) {
        // reset points to zero
        // reset timer
        // reset correct answers
        commit('RESET_TRIVIA')
        
    },
    restartTrivia({ state, commit, dispatch }){
        commit('RESET_TRIVIA')
        let CatID = state.puzzleId

        
        dispatch("getTriviaHiScoreFromLocal",CatID);

        dispatch("goToPuzzleRoute")
    },

    triviaHiScore({ state, commit }, points) {
        let CatID = state.puzzleId;
        let hiScore = state.triviaHiScore; //localStorage.getItem("TriviaHiScore");
        let catHiScore = state.triviaCatHiScore; //localStorage.getItem("TriviaHiScore_" + CatID);
        


        if(points > catHiScore)
        {
            commit('SET_TRIVIA_CATEGORY_HI_SCORE', points)
            localStorage.setItem("TriviaHiScore_" + CatID, points) //save hi score to local
        }

       if(points > hiScore)
        {
            commit('SET_TRIVIA_HI_SCORE', points)
            localStorage.setItem("TriviaHiScore", points) //save hi score to local
        }
            
    },
    
    getTriviaHiScoreFromLocal({ commit }, CatID) {
        let hiScore = localStorage.getItem("TriviaHiScore") !== null ? localStorage.getItem("TriviaHiScore") : 0;
        let cathiScore = localStorage.getItem("TriviaHiScore_" + CatID) !== null ? localStorage.getItem("TriviaHiScore_" + CatID) : 0;

       // commit('SET_TRIVIA_CATEGORY', CatID);

        commit('SET_TRIVIA_HI_SCORE', hiScore) 
        commit('SET_TRIVIA_CATEGORY_HI_SCORE', cathiScore, CatID)
    },
        
    setGameType({ commit }, type) {
        commit('SET_GAME_TYPE', type)
    },
    
    setGameName({ commit }, name) {
        commit('SET_GAME_NAME', name)
    },

    // setAppId({ commit }, appId) {
    //     commit('SET_APP_ID', appId)
    // },
    setUnAuthorised({ commit }, unauthorised){
        commit('SET_UNAUTHORISED', unauthorised)
    },

    setInitialized({ commit }, initialized) {
        commit('SET_INITIALIZED', initialized)
    },

    setTitleHtml({ commit }, titleHtml) {
        commit('SET_TITLE_HTML', titleHtml)
    },

    setCompleted({ commit }, completed) {
        if (completed)
            commit('SET_IS_PLAYING', false)
        
        commit('SET_COMPLETED', completed)
    },

    setIsPlaying({ commit, dispatch }, bool) {
        commit('SET_IS_PLAYING', bool)
        // dispatch('saveToLocalAtIntervals', bool)       
    },

    setIsPaused ({commit}, bool)
    {
        commit('SET_IS_PAUSED',bool)
    },

    setGameLoaded({ commit }, bool){
        commit('SET_GAME_LOADED', bool)
    },

    saveToLocal({ rootGetters, state }) {
        let puzzle = state
        if (state.type === 'crossword' || state.type === 'sudoku' || state.type === 'codecracker' )
            puzzle.inputs = rootGetters['grid/getUserinputs']

        if (state.type === 'wordsearch')
            puzzle.words = rootGetters['wordlist/convertForLocal']

        localStorage.setItem(`puzzle-${ puzzle.puzzleId }`, JSON.stringify(puzzle))
    },

    setTotalTime({ commit }, time) {        
        commit('SET_TOTAL_TIME', time)
    },

    removeMarkAtPosAfterHint({ commit, state, rootState }, payload) {
        if (!payload) 
            throw new Error('Cell row and payloadition required. Given: ' + payload)

            let cell = rootState.grid.cells[payload.row][payload.col] // rootState.grid.selectedCell 
            let markIndex = payload.input-1

            Vue.set(cell.marks, markIndex, false)
    },

    removeAllMarksAfterHint({ rootState }){
        let cell = rootState.grid.selectedCell 

        for(let i = 0; i < cell.marks.length; i++)
        {
           
            Vue.set(cell.marks, i, false)
        }
    },

    clearRelatedPencilMarksAfterHint({ commit, dispatch, state, rootState, getters }, payload){
        let thisSelection = rootState.grid.selectedCell;

        let thisGroup = thisSelection.group;
        let thisRow = thisSelection.row; //or could use payload.row
        let thisCol = thisSelection.col; //or could use payload.col


        // Remove Pencil Marks for the selected cell
        let selPayload = {
            row: rootState.grid.selectedCell.row,
            col: rootState.grid.selectedCell.col,
            input: rootState.grid.selectedCell.input
        }

        dispatch('removeAllMarksAfterHint')

        //1. Loop through the rows
        // loop across horizontal cells which means transversing the cols but only for the row

        for (let i = 0; i < rootState.grid.cols; i++) 
        {
            let newPayload = {
                row: thisRow, 
                col: i,
                input: payload.input,
                }
                
                dispatch('removeMarkAtPosAfterHint', newPayload)

        }

        //2. Loop through the cols
        // loop across horizontal cells which means transversing the cols but only for the row
        for (let i = 0; i < rootState.grid.rows; i++) 
        {
            let newPayload = {
                row: i, 
                col: thisCol,
                input: payload.input,
                }

                dispatch('removeMarkAtPosAfterHint', newPayload)

        }

        //3. Loop through the group
        for (let oRow = 0; oRow < rootState.grid.rows; oRow++) 
        {
            for (let oCol = 0; oCol < rootState.grid.cols; oCol++)
            {
                let oCell = rootState.grid.cells[oRow][oCol]
                let oCellGroup = oCell.group

                if(oCellGroup === thisGroup)
                {
                    let newPayload = {
                        row: oRow, 
                        col: oCol,
                        input: payload.input,
                        }
        
                        dispatch('removeMarkAtPosAfterHint', newPayload)
                }
            }
        }
    },

    clearPencilMarks({ dispatch }){
        dispatch('removeAllMarksAfterHint')
    },

    getPuzzleBestTime({ commit, dispatch, state, rootState, getters })
    {
        let localBest = localStorage.getItem("PuzzleBestTime_" + window.PE_CLIENTAPP_ID) !== null ? localStorage.getItem("PuzzleBestTime_" + window.PE_CLIENTAPP_ID) : 0;
        commit('SET_BEST_TIME', localBest) 
    },

    setPuzzleBestTime({ commit, dispatch, state, rootState, getters }, time)
    {
        let penaltyTime = time + (HintPenaltyMultiplier * state.hintsUsed)
         dispatch('getPuzzleBestTime')

        let currentBestTime = state.puzzleBestTime;

        if(penaltyTime < currentBestTime || currentBestTime === 0)
        {
            
            localStorage.setItem("PuzzleBestTime_" + window.PE_CLIENTAPP_ID, penaltyTime)
            commit('SET_BEST_TIME', penaltyTime);
        }
            

    },
    getSudokuBestTime({ commit }, level)
    {
        let puzzleIdentifier = "SudokuBestTime_" + window.PE_CLIENTAPP_ID + "_" + level
        let localBest = localStorage.getItem(puzzleIdentifier) !== null ? localStorage.getItem(puzzleIdentifier) : 0;

        commit('SET_BEST_TIME', localBest) 
    },
    setSudokuBestTime({ commit, dispatch, state, rootState }, time)
    {
        let level = rootState.game.level
        let puzzleName = rootState.game.titleHtml
        puzzleName = puzzleName.replace(/\s+/g, '-').toLowerCase();//remove spaces and replace with -

        // the idea is to get the time from local storage as it will be the best time. We then compare to this time and update if applicable
        dispatch('getSudokuBestTime',level)

        let penaltyTime = time + (sudokuHintPenaltyMultiplier * state.hintsUsed)
        let currentBestTime = state.puzzleBestTime;
        let puzzleIdentifier = "SudokuBestTime_" + window.PE_CLIENTAPP_ID + "_" + level

        if(penaltyTime < currentBestTime || currentBestTime === 0)
        {
            localStorage.setItem(puzzleIdentifier, penaltyTime)
            commit('SET_BEST_TIME', penaltyTime);
        }
    }


 }

const mutations = {

    // int
    ADD_POINTS(state, points) {
        if (state.points === null) state.points = 0
        state.points += points
    },

    // int
    SET_TRIVIA_HI_SCORE(state, points) {
        state.triviaHiScore = points;
    },

     // int
     SET_TRIVIA_CATEGORY_HI_SCORE(state, points) {
        state.triviaCatHiScore = points;
    },   

    // int
    SET_TRIVIA_CATEGORY(state, CatID)
    {
        state.TriviaCatID = CatID;
    },

    // int
    RESET_TRIVIA(state)
    {
        state.points = 0;
        state.correctOnFirst = 0;
    },

    // string
    SET_GAME_TYPE(state, type) {
        state.type = type
    },
    // string
    SET_GAME_NAME(state, name) {
        state.name = name
    },
    // string
    SET_PUZZLE_LEVEL(state, level) {
        state.level = level
    },

    // number
    SET_PUZZLE_ID(state, puzzleId) {
        state.puzzleId = Number(puzzleId)
    },

    // boolean
    SET_UNAUTHORISED(state, unauthorised) {
        state.unauthorised = unauthorised
    },

    // boolean
    SET_INITIALIZED(state, initialized) {
        state.initialized = initialized
    },

    // boolean
    SET_COMPLETED(state, completed) {
        state.completed = completed
    },

    // boolean
    SET_IS_PLAYING(state, isPlaying) {
        state.isPlaying = isPlaying
    },

    // boolean
    SET_IS_PAUSED(state, isPaused){
        state.isPaused = isPaused
    },

    SET_TOTAL_TIME(state, time) {
        state.totalTime = time
    },

    SET_APP_ID(state, appId) {
        state.appId = appId
    },

    SET_PLAY_ID(state, playId) {
        state.playId = playId
    },

    SET_TITLE_HTML(state, titleHtml) {
        state.titleHtml = titleHtml
    },

    SET_HINTS_USED(state, hintsUsed) {
        state.hintsUsed = hintsUsed
    },

    SET_FINISH_RECORDED(state, finishRecorded) {
        state.finishRecorded = finishRecorded
    },

    INCREMENT_HINTS_USED(state, hintsUsed = 1) {
        state.hintsUsed += hintsUsed
    },

    // p = {row, col, input}
    REMOVE_USER_MARK_AT_POS(rootState, p) {   
 
        let cell = rootState.grid.cells[p.row][p.col]

        p.input--

        Vue.set(cell.marks, p.input, false)
    },

    SET_GAME_LOADED(state, val){
        state.gameLoaded = val
    },

    
    SET_BEST_TIME(state, time) {
        state.puzzleBestTime = time;

    }, 

    SET_COMPETITION_ID(state, val){
        state.competitionID = val;
    },

    SET_COMPETITION_TITLE(state, val){
        state.competitionTitle = val;
    }
}

export {
    state,
    getters,
    actions,
    mutations,
}